/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfilePicture
 */
export interface ProfilePicture {
    /**
     * 
     * @type {string}
     * @memberof ProfilePicture
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilePicture
     */
    baseUrl: string;
    /**
     * 
     * @type {number}
     * @memberof ProfilePicture
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfilePicture
     */
    height?: number;
}

/**
 * Check if a given object implements the ProfilePicture interface.
 */
export function instanceOfProfilePicture(value: object): value is ProfilePicture {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('baseUrl' in value) || value['baseUrl'] === undefined) return false;
    return true;
}

export function ProfilePictureFromJSON(json: any): ProfilePicture {
    return ProfilePictureFromJSONTyped(json, false);
}

export function ProfilePictureFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfilePicture {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'baseUrl': json['baseUrl'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
    };
}

export function ProfilePictureToJSON(value?: ProfilePicture | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'baseUrl': value['baseUrl'],
        'width': value['width'],
        'height': value['height'],
    };
}

